import type { DesignBody } from '@repo/api-contracts';
import { type ReactElement, useState } from 'react';
import { Button, ContentCard, DesignThumbnail } from '@/shared/ui';
import { QuoteDesignViewDialog } from './quote-design-view-dialog';

export interface QuoteDesignPreviewProps {
  readonly quoteRequestId: string;
  /** 견적 썸네일(worker 가 견적 사본으로 그린 그림) 서명 주소. 아직 없으면 null. */
  readonly thumbnailUrl: string | null;
  readonly designName: string;
  /** 견적 사본의 디자인 본문 — 디자인 보기 창이 이것을 그린다. */
  readonly designBody: DesignBody;
}

/**
 * 디자인 사본(견적 설계 §6-2) — 견적 썸네일과 '디자인 보기' 버튼. 썸네일이 아직 없거나 불러오지 못하면 "미리보기 준비 중".
 * 버튼은 읽기 전용 뷰어 창(면 전환·확대, 뷰어 설계 V2)을 연다 — 창이 열려 있을 때만 그리고, 그때만 뷰를 조회한다.
 */
export const QuoteDesignPreview = ({
  quoteRequestId,
  thumbnailUrl,
  designName,
  designBody,
}: QuoteDesignPreviewProps): ReactElement => {
  const [viewing, setViewing] = useState(false);

  return (
    <ContentCard title="디자인">
      <p className="text-sm text-muted-foreground wrap-anywhere">{designName}</p>
      <DesignThumbnail url={thumbnailUrl} alt={designName} className="mt-3 max-w-xs" />
      <Button
        type="button"
        variant="outline"
        size="sm"
        className="mt-4"
        aria-haspopup="dialog"
        onClick={() => setViewing(true)}
      >
        디자인 보기
      </Button>
      {viewing ? (
        <QuoteDesignViewDialog
          quoteRequestId={quoteRequestId}
          designBody={designBody}
          onClose={() => setViewing(false)}
        />
      ) : null}
    </ContentCard>
  );
};
